var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"text-center"},[_c('small',{staticClass:"text-muted"},[_vm._v(" "+_vm._s(this.num)+" "+_vm._s(this.lab)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }